import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const DashboardBookList = ({
  books, title, bookCount, linkMore, shouldShowBookOrder, extraClassName, rubrics, itemKey,
}) => {
  const rubricsLength = get(rubrics, 'length', 0);
  const booksLength = get(books, 'length', 0);
  const showBooksLink = linkMore && booksLength > 6;

  return (
    <div className={classNames('billetContainerNoOverflow', styles.container, extraClassName)}>
      <div className={styles.wrapper}>
        {rubricsLength > 0 && (
          <ul className={styles.rubrics}>
            {rubrics.map((rubric, idx) => (
              <li className={styles.rubricsItem} key={`${itemKey}-${rubric.id}`}>
                {rubric.name.trim()}{rubricsLength-1 > idx && ', '}
              </li>
            ))}
          </ul>
        )}
        {showBooksLink && (
          <Link
            to={linkMore}
            className={classNames(styles.linkMore, { hasNoRubrics: !rubricsLength })}>
            <span className={styles.linkMoreText}>
              {bookCount} {pluralize(bookCount, 'книга', 'книги', 'книг')}
            </span>
            <span className="arrowRight" />
          </Link>
        )}
        <div>
          {linkMore
            ? (
              <Link
                to={linkMore}
                className={classNames(
                  'title-2',
                  'jest-dashboard-booklist-link',
                  styles.title,
                  { hasNoRubrics: !rubricsLength && showBooksLink }
                )}>
                {title}
              </Link>
            )
            : <div className={classNames(styles.title, 'title-2')}>{title}</div>
          }
        </div>
        <div className={styles.slider}>
          <VerticalBookCardList
            bookList={books}
            shouldShowBookOrder={shouldShowBookOrder}
            visibleElements="6" />
        </div>
      </div>
    </div>
  );
};

DashboardBookList.propTypes = {
  title: PropTypes.string.isRequired,
  books: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })),
};

export default DashboardBookList;
